import React from 'react';
import { string } from 'prop-types';
import s from './SchedulingRules.css';


/*
  With great power, comes great responsibility:
  https://facebook.github.io/react/docs/dom-elements.html#dangerouslysetinnerhtml
*/
const SchedulingRules = ({ ...props }) => {
  const schedulingInstructions = props.data;
  const html = <section className={s.component} dangerouslySetInnerHTML={{__html: schedulingInstructions}} />;

  return (schedulingInstructions ? html : false);
};

SchedulingRules.propTypes = {
  data: string,
};

export default SchedulingRules;



// WEBPACK FOOTER //
// ./src/components/Pages/Appointments/Scheduling/Rules/SchedulingRules.js